import { commitMutation,
  graphql } from 'react-relay';
import environment from '../../index';
import { basicMutationOnCompleted, onErrorMutation } from '../common/common';

const mutation = graphql`
  mutation SetArchiveStatusOffersMutation($offerIds: [ID!]!, $isArchived: Boolean!) {
    setArchiveStatus(offerIds: $offerIds, isArchived: $isArchived) {
      ok
      error
    }
  }
`;

export default ({ offerIds, isArchived }, done) => {
  const variables = { offerIds, isArchived };

  commitMutation(
    environment(),
    {
      mutation,
      variables,
      onCompleted: ({ setArchiveStatus }) => basicMutationOnCompleted(setArchiveStatus, done),
      onError: error => onErrorMutation(error, done)
    }
  );
};
